import ClientSetManagement from "../../features/clientsetmanagement";

const ClientSetManagementPage = () => <ClientSetManagement />;

export default ClientSetManagementPage;